import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'

import { PersonatabService } from './personatab.service'
import { ElectricityService } from './electricity.service'
import { StateService } from './state.service'
import { SmartTableService } from './smart-table.service'
import { PlayerService } from './player.service'
import { DjService } from './dj.service'
import { GenreService } from './genre.service'
import { GenretimeframeService } from './genretimeframe.service'
import { StationService } from './station.service'
import { MusicService } from './music.service'
import { MusicrowService } from './musicrow.service'
import { RunningService } from './running.service'
import { TracklistService } from './tracklist.service'
import { ReportService } from './report.service'
import { UsersService } from './users.service'
import { CoachService } from './coach.service'
import { PartnerService } from './partner.service'
import { EyeDropperService } from './eyedropper.service'

const SERVICES = [
  ElectricityService,
  PersonatabService,
  StateService,
  SmartTableService,
  PlayerService,
  DjService,
  GenreService,
  GenretimeframeService,
  StationService,
  MusicService,
  MusicrowService,
  RunningService,
  TracklistService,
  ReportService,
  UsersService,
  CoachService,
  PartnerService,
  EyeDropperService,
]

@NgModule({
  imports: [CommonModule],
  providers: [...SERVICES],
})
export class DataModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: DataModule,
      providers: [...SERVICES],
    }
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/data.module.ts